export default __webpack_public_path__ + "static/media/logonew.c4bf9912.png";